<template>
  <div>
    <div class="image-container">
      <div class="overray"></div>
      <div class="middletext">{{ $t("home.smartcontrol") }}</div>
      <!-- 手机截图 -->
      <img
        :style="{ width: isWideScreen ? '500px' : '95%' }"
        src="../assets/phonedemo.png"
        alt=""
      />
      <!-- {{ testtxt }} -->
      <div class="middlebutton">
        <!-- 二维码 -->
        <div class="qr-tooltip" v-if="showQR && isWideScreen">
          <img class="qr-img" src="../assets/barcode.png" alt="QR Code" />
        </div>
        <el-button
          class="animated-button"
          type="primary"
          size="large"
          @mouseover.native="showQRCode"
          @mouseleave.native="hiddenQRCode"
          round
          @click="startHacking"
        >
          <div style="display: flex;">
            <svg
              class="svg-ios"
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              :color="iconColor"
              viewBox="0 0 17 20"
            >
              <g>
                <g>
                  <path
                    fill="#ffffff"
                    d="M17.014 14.452c-.025.067-.44 1.393-1.447 2.763-.87 1.183-1.772 2.36-3.195 2.384-1.399.025-1.848-.77-3.447-.77s-2.098.746-3.42.795c-1.373.048-2.42-1.278-3.297-2.457C.414 14.756-.956 10.353.885 7.382a5.174 5.174 0 0 1 4.32-2.436c1.348-.022 2.622.846 3.445.846.825 0 2.372-1.044 3.998-.89.68.026 2.592.255 3.818 1.923-.097.06-2.28 1.239-2.254 3.7.028 2.936 2.77 3.913 2.802 3.927zM8.484 4.68c-.157-1.116.434-2.277 1.11-3.005.753-.821 2.025-1.431 3.075-1.47.134 1.137-.358 2.278-1.087 3.1-.73.82-1.925 1.46-3.097 1.375z"
                  ></path>
                </g>
              </g>
            </svg>

            <span
              style="
                font-size: medium;
                margin: 0;
                align-content: center;
              "
              >{{ $t("home.downloadnow") }}</span
            >
          </div>
        </el-button>
      </div>
    </div>
    <div style="background-color: white;">
      <ProductIntro :isWideScreen="isWideScreen" />
    </div>

    <div class="weixin-show-section" v-if="showGuide" @click="showGuide = false">
      <img class="jiantou" src="../assets/yindao.png" alt="" />
      <div class="txtsection">
        <p>1、点击右上角按钮</p>
        <p>2、选择 
          <img src="../assets/m.jpg" alt="">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Tooltip } from "element-ui";
import ProductIntro from '../components/ProductIntro.vue';

export default {
  name: "home",
  components: {
    ElButton: Button,
    ElTooltip: Tooltip,
    ProductIntro
  },
  props: {
    isWideScreen: Boolean,
  },

  data() {
    return {
      showGuide: false,
      // testtxt: "test",
      showQR: false,
      iconColor: "#ff0000", // 设置图标颜色
      // showUrl: "https://wgx-bucket.oss-ap-southeast-1.aliyuncs.com/phone_pro_img-2.png",
    };
  },
  mounted() {
    this.startAnimation();
  },
  methods: {
    startHacking() {
      // 判断是否在微信内打开  
      var ua = navigator.userAgent.toLowerCase();
      
      var isWeixin = ua.indexOf('micromessenger') != -1;

      if (isWeixin == true) {
        // 显示一个指引图片 
        this.showGuide = true
      }
      window.open("https://itunes.apple.com/cn/app/id6477153043", "_blank");
    },

    startAnimation() {
      setInterval(() => {
        const button = document.querySelector(".animated-button");
        if (button) {
          button.classList.toggle("animate");
        }
      }, 1000); // 每隔1秒切换动画类
    },
    showQRCode() {
      this.showQR = true;
    },
    hiddenQRCode() {
      this.showQR = false;
    },
  },
};
</script>
<style scoped>
.image-container {
  position: relative;
  height: 650px;
  /* 容器宽度设为100%以填满其父容器 */
  width: auto;
  max-width: 100%;
}
.overray {
  position: absolute;
  /* 设置一个固定的高度值 */
  height: 650px;
  /* 容器宽度设为100%以填满其父容器 */
  border: 0;
  width: 100%;
  /* 设置背景图片 */
  background-image: url("../assets/homebg.jpg");
  /* 确保图片覆盖整个容器并且保持其宽高比 */
  background-size: cover;
  background-repeat: no-repeat;
  /* 确保背景图片始终居中显示 */
  background-position: center;
  filter: blur(1.3px);
  box-shadow: 0 0 0 190px rgba(0, 0, 0, 1); /* 使用 box-shadow 模拟边框 */
  z-index: -1;
}
.image-container img {
  top: 0;
  left: 0;
  width: 440px;
  height: auto;
  object-fit: fill;
  object-position: center;
}
.middletext {
  padding-top: 75px;
  padding-bottom: 35px;
  color: white;
  font-size: 2.1em;
  font-weight: lighter;
}
.middlebutton {
  margin-top: 70px;
  color: white;
}
.svg-ios {
  color: white;
  margin-right: 10px;
}
.qr-tooltip {
  margin-top: 30px;
  position: absolute;
  width: 100px;
  background-color: white;
  border-radius: 15px;
  padding: 8px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 0%);
}
.qr-tooltip img {
  width: 100%;
  height: 100%;
  vertical-align: middle;
  /* height: 50px; */
}

.animated-button {
  transition: transform 0.5s ease-in-out;
  animation: pulse-animation 2s infinite alternate;
}

@keyframes pulse-animation {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.1);
  }
}

.animated-button.animate {
  animation: pulse-animation 2s infinite alternate;
}

.weixin-show-section
{
  position: absolute; 
  top: 0; 
  right: 0; 
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}
.txtsection
{
    float: right;
    position: relative;
    margin-top: 100px;
    color: white;
    border-radius: 10px;
    background-color: rgba(50, 50, 50, 0.9);
    padding: 15px;
    padding-right: 25px;
}

.txtsection p {
  text-align: left;
}

.txtsection img {
  width: 80px;
}

.jiantou
{
  float: right;
  position: relative;
  margin-right: 3px;
  margin-top: 3px;
  text-align: right;
  align-items: end;
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/home.vue